// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.reviews[data-v-5be8faf8] {

    display: flex;

    flex-direction: column
}
@media (min-width: 996px) {
.reviews[data-v-5be8faf8] {

        flex-direction: row
}
}
.reviews__stats[data-v-5be8faf8] {

    --tw-bg-opacity: 1;

    background-color: rgb(234 178 38 / var(--tw-bg-opacity))
}
@media (min-width: 996px) {
.reviews__stats[data-v-5be8faf8] {

        width: 50%
}
}
.reviews__stats__content[data-v-5be8faf8] {

    padding-top: 4rem;

    padding-bottom: 3rem;

    text-align: center
}
@media (min-width: 996px) {
.reviews__stats__content[data-v-5be8faf8] {

        float: right;

        margin-right: 25%;

        padding-top: 7.5rem;

        padding-bottom: 7.5rem;

        text-align: left
}
}
@media (min-width: 1320px) {
.reviews__stats__content[data-v-5be8faf8] {

        margin-right: 0.75rem;

        width: calc((1320px - 1.5rem) / 12 * 5 - 1.5rem)
}
}
.reviews__stats__title[data-v-5be8faf8] {

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.5rem;

    font-weight: 700
}
@media (min-width: 996px) {
.reviews__stats__title[data-v-5be8faf8] {

        font-family: Mont;

        line-height: 1;

        font-size: 2.5rem;

        font-weight: 700
}
}
.reviews__stats__info[data-v-5be8faf8] {

    margin-top: 2.5rem;

    --tw-text-opacity: 1;

    color: rgb(31 47 75 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 700
}
.reviews__stats__info__highlight[data-v-5be8faf8] {

    display: block;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity));

    font-family: Mont;

    line-height: 1;

    font-size: 3.75rem;

    font-weight: 700
}
.reviews__comments[data-v-5be8faf8] {

    --tw-bg-opacity: 1;

    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
@media (min-width: 996px) {
.reviews__comments[data-v-5be8faf8] {

        width: 50%;

        padding-right: 1.5rem
}
}
.reviews__comments__content[data-v-5be8faf8] {

    padding-top: 1.5rem;

    padding-bottom: 2rem
}
@media (min-width: 996px) {
.reviews__comments__content[data-v-5be8faf8] {

        margin-left: 1.5rem;

        display: flex;

        height: 100%;

        flex-direction: column;

        justify-content: center
}
}
@media (min-width: 1320px) {
.reviews__comments__content[data-v-5be8faf8] {

        margin-left: 5rem;

        width: calc((1320px - 1.5rem) / 12 * 5 - 1.5rem)
}
}
.reviews__comments__wrapper[data-v-5be8faf8] {

    position: relative;

    overflow-x: auto
}
@media (min-width: 996px) {
.reviews__comments__wrapper[data-v-5be8faf8] {

        max-width: 100%;

        overflow-x: clip
}
}
.reviews__comments__wrapper__horizontal[data-v-5be8faf8] {

    display: flex;

    flex-direction: row;

    padding-left: 1.5rem;

    padding-right: 1.5rem
}
.reviews__comments__list[data-v-5be8faf8] {

    left: 0;

    display: inline-flex;

    height: 13rem;

    width: 100%;

    flex-direction: row;

    padding-left: 1rem;

    padding-right: 1rem
}
@media (min-width: 640px) {
.reviews__comments__list[data-v-5be8faf8] {

        padding-left: 1.5rem;

        padding-right: 1.5rem
}
}
@media (min-width: 996px) {
.reviews__comments__list[data-v-5be8faf8] {

        padding-left: 0;

        padding-right: 0
}
}
.reviews__comments__footer[data-v-5be8faf8] {

    margin-top: 2rem;

    display: flex;

    flex-direction: column;

    align-items: center
}
@media (min-width: 996px) {
.reviews__comments__footer[data-v-5be8faf8] {

        margin-top: 2.5rem;

        margin-left: 4rem;

        align-items: flex-end
}
}
.reviews__comments__footer__content[data-v-5be8faf8] {

    display: flex;

    align-items: center;

    justify-content: center;

    --tw-text-opacity: 1;

    color: rgb(31 47 75 / var(--tw-text-opacity))
}
@media (min-width: 996px) {
.reviews__comments__footer__content[data-v-5be8faf8] {

        justify-content: flex-end
}
}
.reviews__comments__footer__controls[data-v-5be8faf8] {

    margin-top: 1.5rem;

    display: flex;

    width: 100%;

    flex-direction: row;

    align-items: center;

    justify-content: center
}
@media (min-width: 996px) {
.reviews__comments__footer__controls[data-v-5be8faf8] {

        justify-content: space-between
}
}
.reviews__comments__footer__controls .carousel-controls[data-v-5be8faf8] {

    display: none
}
@media (min-width: 996px) {
.reviews__comments__footer__controls .carousel-controls[data-v-5be8faf8] {

        display: flex
}
}
.reviews__comments__footer__global[data-v-5be8faf8] {

    font-family: Mont;

    font-size: 0.875rem;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(31 47 75 / var(--tw-text-opacity))
}
.reviews__comments__footer__wrapper[data-v-5be8faf8] {

    margin-left: 0.5rem;

    display: flex;

    flex-direction: column;

    align-items: center
}
.reviews__comments__footer__wrapper img[data-v-5be8faf8] {

    margin-top: 0.25rem
}
.reviews__comments__footer__rate[data-v-5be8faf8] {

    position: relative;

    display: inline-flex;

    width: 4rem;

    justify-content: space-around
}
.reviews__comments__footer__rate__icon[data-v-5be8faf8] {

    flex-shrink: 0;

    display: inline-block;

    background-size: contain;

    background-repeat: no-repeat;

    width: 0.75rem;

    height: 0.75rem;

    background-image: url("/img/web/icons/star-black.svg")
}
.reviews__comments__footer__external-link[data-v-5be8faf8] {

    display: flex;

    --tw-text-opacity: 1;

    color: rgb(156 163 175 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400;

    text-decoration: underline
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/reviews/Reviews.vue"],"names":[],"mappings":";AA0IA;;IAAA,aAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,YAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA,sBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,cAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA,cAAA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,iBAAA;;IAAA,cAAA;;IAAA,kBAAA;;IAAA;AAAA;AAMA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,UAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,aAAA;;QAAA,YAAA;;QAAA,sBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,eAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAKA;;IAAA,OAAA;;IAAA,oBAAA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,oBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,eAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,gBAAA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,uBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,kBAAA;;IAAA,oBAAA;;IAAA,WAAA;;IAAA;AAAA;AAGA;;IAAA,cAAA;;IAAA,qBAAA;;IAAA,wBAAA;;IAAA,4BAAA;;IAAA,cAAA;;IAAA,eAAA;;IAAA;AAAA;AAKA;;IAAA,aAAA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <section class=\"reviews\">\n    <div class=\"reviews__stats\">\n      <div class=\"reviews__stats__content\">\n        <h2 class=\"reviews__stats__title\">Nos avalan</h2>\n        <p class=\"reviews__stats__info\"><span class=\"reviews__stats__info__highlight\">+5000</span>Familias felices</p>\n        <p class=\"reviews__stats__info\"><span class=\"reviews__stats__info__highlight\">+1000M €</span>Valor total de hipotecas</p>\n        <p class=\"reviews__stats__info\"><span class=\"reviews__stats__info__highlight\">2,54%</span>TIN promedio</p>\n      </div>\n    </div>\n\n    <div class=\"reviews__comments\">\n      <div class=\"reviews__comments__content\">\n        <div class=\"reviews__comments__wrapper\">\n          <Viewport>\n            <template #xs>\n              <div class=\"reviews__comments__wrapper__horizontal\">\n                <Review v-for=\"(review, i) in reviews\" :key=\"i\" :slot=\"i\" :review=\"review\" />\n              </div>\n            </template>\n\n            <template #lg>\n              <Carousel\n                v-model=\"slide\"\n                orientation=\"horizontal\"\n                transition-easing=\"cubic-bezier(1, 0.06, 0, 0.93)\"\n                class=\"reviews__comments__list\"\n                :controls=\"false\"\n                :arrows=\"false\"\n                :transition-duration=\"350\"\n              >\n                <Review v-for=\"(review, i) in reviews\" :slot=\"i\" :key=\"i\" :review=\"review\" />\n              </Carousel>\n            </template>\n          </Viewport>\n        </div>\n\n        <div class=\"reviews__comments__footer\">\n          <div class=\"reviews__comments__footer__content\">\n            <p class=\"reviews__comments__footer__global\">4.9</p>\n            <div class=\"reviews__comments__footer__wrapper\">\n              <div class=\"reviews__comments__footer__rate\">\n                <i class=\"reviews__comments__footer__rate__icon\"></i>\n                <i class=\"reviews__comments__footer__rate__icon\"></i>\n                <i class=\"reviews__comments__footer__rate__icon\"></i>\n                <i class=\"reviews__comments__footer__rate__icon\"></i>\n                <i class=\"reviews__comments__footer__rate__icon\"></i>\n              </div>\n              <img src=\"img/web/icons/Google.svg\" alt=\"Logo Google\" />\n            </div>\n          </div>\n          <div class=\"reviews__comments__footer__controls\">\n            <CarouselControls\n              inline\n              v-model=\"slide\"\n              :count=\"reviews.length\"\n              :dot-style=\"{\n                border: '1px solid #1E2F4B',\n                backgroundColor: 'transparent',\n                boxShadow: 'none',\n              }\"\n              :dot-selected-style=\"{\n                backgroundColor: '#1E2F4B',\n                boxShadow: 'none',\n                transform: 'scale(1)',\n              }\"\n            />\n            <a class=\"reviews__comments__footer__external-link\" :href=\"reviewsUrl\" target=\"_blank\">\n              Ver todas las valoraciones\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</template>\n\n<script>\nimport { isMobile } from '@/lego/utils/platform/device';\nimport Carousel from '@/lego/components/carousels/Carousel.vue';\nimport CarouselControls from '@/lego/components/carousels/CarouselControls.vue';\nimport { ref } from '@vue/composition-api';\nimport Viewport from '@/lego/components/tools/Viewport.vue';\nimport Review from '@/lego/partials/home/reviews/Review.vue';\n\nexport default {\n  components: { Carousel, CarouselControls, Viewport, Review },\n\n  setup() {\n    return {\n      slide: ref(0),\n      reviews: [\n        {\n          name: 'Elvira Pérez',\n          image: 'elvira',\n          numberOfReviews: '2 valoraciones',\n          whenLastReview: 'Hace 2 días',\n          review:\n            'He tenido muy buena experiencia con Trioteca, gracias a Ronald y especialmente a Cynthia conseguimos que los trámites se resolvieran en un plazo razonable de tiempo. Les estoy muy agradecidos! Totalmente recomendable!',\n          stars: 5,\n        },\n        {\n          name: 'Jeremy Verao',\n          image: 'jeremy',\n          numberOfReviews: '1 valoración',\n          whenLastReview: 'Hace 2 días',\n          review:\n            'TRIOTECA es una estructura muy competente con respecto al proceso de cambio de hipoteca. Laura me ha ayudado mucho y me ha facilitado las tareas. Muy recomendable !',\n          stars: 5,\n        },\n        {\n          name: 'Cristina Martín',\n          image: 'cristina',\n          numberOfReviews: '80 valoraciones',\n          whenLastReview: 'Hace 3 días',\n          review:\n            'Nos ayudaron a conseguir una oferta hipotecaria muy buena y nos acompañaron durante todo el proceso, resolviendo todas nuestras dudas. ¡Gracias!',\n          stars: 5,\n        },\n        {\n          name: 'Carles',\n          image: 'carles',\n          numberOfReviews: '1 valoración',\n          whenLastReview: 'Hace 4 días',\n          review: 'Muy atentos en todo momento. He tenido la tranquilidad de disponer de su ayuda.',\n          stars: 5,\n        },\n      ],\n      reviewsUrl: isMobile()\n        ? 'https://www.google.com/search?q=trioteca+reviews&oq=trioteca+reviews#lkt=LocalPoiReviews&trex=m_t:lcl_akp,rc_f:nav,rc_ludocids:15823220965021819260,rc_q:TRIOTECA,ru_q:TRIOTECA,trex_id:Rpvenc'\n        : 'https://www.google.com/search?q=trioteca+reviews&oq=trioteca+reviews#lrd=0x12a4970918dcf147:0xdb975fa1f6a3a17c,1',\n    };\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.reviews {\n  @apply flex flex-col lg:flex-row;\n\n  &__stats {\n    @apply lg:w-1/2 bg-brand-primary-medium;\n\n    &__content {\n      @apply xl:col-5-12 lg:mr-[25%] lg:float-right xl:mr-micro pt-xl pb-md lg:py-xxxl text-center lg:text-left;\n    }\n\n    &__title {\n      @apply style-subtitle-bold lg:style-title-bold text-neutral-ultradark;\n    }\n\n    &__info {\n      @apply text-brand-secondary style-body-sm-bold mt-sm;\n\n      &__highlight {\n        @apply block text-neutral-white style-display-bold;\n      }\n    }\n  }\n\n  &__comments {\n    @apply lg:w-1/2 lg:pr-xxs bg-neutral-lightest;\n\n    &__content {\n      @apply pt-xxs pb-xs xl:col-5-12 lg:ml-xxs xl:ml-xxl lg:flex lg:flex-col lg:justify-center lg:h-full;\n    }\n\n    &__wrapper {\n      @apply relative overflow-x-auto lg:max-w-full lg:overflow-x-clip;\n\n      &__horizontal {\n        @apply flex flex-row px-xxs;\n      }\n    }\n\n    &__list {\n      @apply w-full h-[13rem] left-0 inline-flex flex-row px-xxxs sm:px-xxs lg:px-0;\n    }\n\n    &__footer {\n      @apply flex flex-col items-center lg:items-end mt-xs lg:mt-sm lg:ml-xl;\n\n      &__content {\n        @apply flex items-center justify-center lg:justify-end text-brand-secondary;\n      }\n\n      &__controls {\n        @apply w-full flex flex-row justify-center lg:justify-between items-center mt-xxs;\n\n        .carousel-controls {\n          @apply hidden lg:flex;\n        }\n      }\n\n      &__global {\n        @apply font-bold font-highlight text-nano text-brand-secondary-medium;\n      }\n\n      &__wrapper {\n        @apply flex flex-col items-center ml-nano;\n\n        img {\n          @apply mt-quark;\n        }\n      }\n\n      &__rate {\n        @apply inline-flex relative w-[4rem] justify-around;\n\n        &__icon {\n          @apply icon icon-micro icon-star-black;\n        }\n      }\n\n      &__external-link {\n        @apply flex style-overline-underline text-neutral-medium;\n      }\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
